import React from 'react';
import DoughnutChart from '../../Charts/DoughnutChart';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import WidgetDescription from '../WidgetDescription';
import { Col, Row } from 'react-bootstrap';
import TableToggle from '../TableToggle';
import KeyValueData from '../../Charts/KeyValueData';
import useTableToggle from '../../Hooks/useTableToggle';
import NoData from '../NoData';
import { colors } from '../../../utilities/formats';

export default function AwardLevelFocus({ institutionData }) {

    const { table, handleTable } = useTableToggle();
    const title = 'Award Level Focus';

    const fields = [
        { "field": 'award_associates_2025', "label": 'Associates', "color": colors.lightblue },
        { "field": 'award_bachelors_2025', "label": 'Bachelor\'s', "color": colors.green },
        { "field": 'award_masters_2025', "label": 'Master\'s', "color": colors.orange },
        { "field": 'award_doctorates_2025', "label": 'Doctorates', "color": colors.red },
    ];

    const awards = [];
    fields.forEach((field) => {
        const value = institutionData.post_meta[field.field].value.replace('%', '');
        if (value != 0) {
            awards.push({
                label: field.label,
                value: parseFloat(value),
                color: field.color,
            });
        }
    });

    const label = institutionData.post_meta.ic2025alf.label

    if (!label) {
        return <NoData widgetTitle={title} />;
    }

    return (
        <Widget className="award-level-focus">
            <Row>
                <Col>
                    <WidgetTitle>{title}</WidgetTitle>
                </Col>
                <Col xs={12} sm={3}>
                    <TableToggle handleTable={handleTable} table={table} />
                </Col>
            </Row>
            <WidgetDescription>
                The primary award level(s) in which the institution awards degrees.
            </WidgetDescription>

            {!table ? (
                <div className="d-block d-md-flex">
                    <div className="w-50">
                        <DoughnutChart
                            data={awards}
                            centerText={label}
                            legendDiv="awardsLegend"
                            numberFormat="percent"
                            colorRamp={awards.map((award) => award.color)}
                        />
                    </div>
                    <div className='dotLegend w-50 d-flex align-items-center p-3' id='awardsLegend'></div>
                </div>
            ) : <KeyValueData data={awards} numberFormat="percent" />}
        </Widget>
    );
}